/**
 * @generated SignedSource<<58d3901c1d0b8bd942b1e2cc541abd78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoCard_page$data = {
  readonly content: {
    readonly __typename: string;
  };
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"ItemLocationInfo_item">;
  readonly " $fragmentType": "TodoCard_page";
};
export type TodoCard_page$key = {
  readonly " $data"?: TodoCard_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoCard_page">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoCard_page",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemLocationInfo_item"
    }
  ],
  "type": "FolderItem",
  "abstractKey": null
};

(node as any).hash = "2f7005ae83aed6b14b5610a29f599e34";

export default node;
